/*
 *
 * ----------------------------------------------- */

$(function () {
  var $button = $(".btn-common");
  $button.hover(
    function () {
      $("body").addClass("hovering");
    },
    function () {
      $("body").removeClass("hovering");
    }
  );
});
